import React from "react"
import { LanguageProvider } from "./src/contexts/LanguageContext"

// Import global styles
import "./src/styles/global.css"

// Wrap the entire app with LanguageProvider
export const wrapRootElement = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>
}
